// src/components/ui/LoadingScreen.tsx
import { motion } from "framer-motion";

const LogoEganesha = "/e-ganesha.png";

interface LoadingScreenProps {
  message?: string;
  subMessage?: string;
  fullScreen?: boolean; // True untuk SsoCallback (layar penuh), False untuk dalam layout
}

export default function LoadingScreen({
  message = "Memuat data...",
  subMessage = "Mohon tunggu sebentar",
  fullScreen = true,
}: LoadingScreenProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center w-full h-screen bg-slate-50/50 backdrop-blur-sm ${
        fullScreen ? "h-screen" : "h-full min-h-[60vh]"
      }`}
    >
      {/* Animasi Spinner Modern */}
      <div className="mb-6">
        <motion.img
          src={LogoEganesha}
          alt="logo"
          width={50}
          height={50}
          className="rounded-full border dark:border-none"
          animate={{
            scale: [1, 2, 2, 1, 1],
            rotate: [0, 0, 270, 270, 0],
            borderRadius: ["20%", "50%", "20%", "20%", "50%"],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: "loop",
            ease: "easeInOut",
            delay: 0.5,
          }}
        />
      </div>

      {/* Tipografi yang Elegan */}
      <h3 className="text-lg font-semibold text-slate-700 text-center px-4">
        {message}
      </h3>
      {subMessage && (
        <p className="text-sm text-slate-500 mt-2 animate-pulse text-center px-4">
          {subMessage}
        </p>
      )}
    </div>
  );
}
